import { session } from './session';
import Constants from '../app.constants';

class AnalyticService {
  constructor() {
    this.Session = session;
    this.ga = window.ga;
    this.Constants = Constants;

    this.dimensionMap = {
      timestamp: 'dimension1',
      query: 'dimension2',
      bam_link_id: 'dimension3',
      user_id: 'dimension4',
      is_admin: 'dimension5',
      group_field: 'dimension6',
      org_id: 'dimension7',
      publisher_type: 'dimension10',
    };
    this.propertyID = '64241223-1';
  }

  setUp(isRelease, user) {
    // Opt-out of all analytics and tracking when not in release
    if (!isRelease) {
      window[`ga-disable-UA-${this.propertyID}`] = true;
      return;
    }

    if (!user) return;

    this.ga('set', { '&uid': user.userId });
  }

  trackEvent(category, action, label, params, type = 'event') {
    params = this.buildEventParams(params);
    const gaParams = {};

    Object.keys(params).forEach(key => {
      if (key in this.dimensionMap) {
        gaParams[this.dimensionMap[key]] = params[key] ? params[key].toString() : null;
      }
    });

    if (type === 'pageview') {
      this.ga('send', 'pageview', category, gaParams);
    } else {
      this.ga('send', 'event', category, action, label, gaParams);
    }
  }

  buildEventParams(params) {
    params = params || {};
    if (this.Session) {
      Object.assign(params, {
        timestamp: new Date().toISOString(),
        is_admin: this.Session.isAdmin ? 'true' : 'false',
        org_id: this.Session.orgId,
        publisher_type: this.Session.publisher_type,
        user_role: this.Session.userRole,
        user_id: this.Session.userId,
      });
    }

    return params;
  }
}

export default new AnalyticService();
